import { BaseListFilter } from '../../../models/base-list-filter.model';

export class DealPromoCodeFilter extends BaseListFilter {}
